export default __webpack_public_path__ + "static/media/rupee.55858673.svg";